import React from 'react'

export const NairaSymbol = ({
  className,
  size,
}: {
  className?: string
  size: number
}) => {
  return (
    <svg
      width={size}
      height={size * (43 / 40)}
      viewBox='0 0 43 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M42.2673 16.4876H0.224609V9.48047H42.2673V16.4876Z'
        fill='currentColor'
      />
      <path
        fill-rule='evenodd'
        clip-rule='evenodd'
        d='M42.2673 30.5032H0.224609V23.4961H42.2673V30.5032Z'
        fill='currentColor'
      />
      <path
        d='M6.06396 39.8453V0.605469H12.3704L30.3927 29.3066V0.605469H36.2226V39.8453H29.9162L11.8939 11.1442V39.8453H6.06396Z'
        fill='currentColor'
      />
    </svg>
  )
}
